import { useState } from 'react';
import { useThemeStore, type Density, type ThemeMode } from '@/stores/theme';
import { Icon } from '@/design-system/icons/Icon';
import { cx } from '@/utils/cx';

export const ThemeDensityPanel = () => {
  const [open, setOpen] = useState(false);
  const theme = useThemeStore((s) => s.theme);
  const density = useThemeStore((s) => s.density);
  const setTheme = useThemeStore((s) => s.setTheme);
  const setDensity = useThemeStore((s) => s.setDensity);

  if (!import.meta.env.DEV) return null;

  if (!open) {
    return (
      <button
        type="button"
        aria-label="Abrir painel de tema"
        onClick={() => setOpen(true)}
        style={{
          position: 'fixed',
          bottom: 18,
          right: 18,
          zIndex: 9000,
          width: 38,
          height: 38,
          borderRadius: '50%',
          border: '1px solid var(--line-2)',
          background: 'var(--surface)',
          color: 'var(--ink-2)',
          cursor: 'pointer',
          boxShadow: 'var(--sh-2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name="sliders" size={16} />
      </button>
    );
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 18,
        right: 18,
        zIndex: 9000,
        background: 'var(--surface)',
        border: '1px solid var(--line-2)',
        borderRadius: 'var(--r-3)',
        boxShadow: 'var(--sh-3)',
        padding: 14,
        display: 'grid',
        gap: 12,
        minWidth: 240,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong style={{ fontSize: 12, fontFamily: 'var(--font-mono)', textTransform: 'uppercase', color: 'var(--ink-3)' }}>
          dev · ajustes
        </strong>
        <button type="button" className="icon-btn" aria-label="Fechar" onClick={() => setOpen(false)} style={{ width: 28, height: 28 }}>
          <Icon name="x" size={14} />
        </button>
      </div>

      <Seg label="Tema" options={[['light', '☀ Claro'], ['dark', '☾ Escuro']]} value={theme} onPick={(v) => setTheme(v as ThemeMode)} />
      <Seg label="Densidade" options={[['comfortable', 'Confortável'], ['compact', 'Compacta']]} value={density} onPick={(v) => setDensity(v as Density)} />
    </div>
  );
};

const Seg = ({
  label,
  options,
  value,
  onPick,
}: {
  label: string;
  options: Array<[string, string]>;
  value: string;
  onPick: (v: string) => void;
}) => (
  <div>
    <div style={{ fontSize: 11, color: 'var(--ink-3)', marginBottom: 4 }}>{label}</div>
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${options.length}, 1fr)`,
        gap: 3,
        background: 'var(--surface-2)',
        padding: 3,
        borderRadius: 'var(--r-2)',
      }}
    >
      {options.map(([v, lbl]) => (
        <button
          key={v}
          type="button"
          onClick={() => onPick(v)}
          className={cx(value === v && 'active')}
          style={{
            border: 0,
            background: value === v ? 'var(--surface)' : 'transparent',
            color: value === v ? 'var(--primary-deep)' : 'var(--ink-3)',
            padding: '6px 10px',
            borderRadius: 'var(--r-1)',
            cursor: 'pointer',
            fontSize: 12,
            fontWeight: value === v ? 600 : 400,
            boxShadow: value === v ? 'var(--sh-1)' : 'none',
          }}
        >
          {lbl}
        </button>
      ))}
    </div>
  </div>
);
